import { MinusOutlined, PlusOutlined } from "@ant-design/icons";
import { Button } from "antd";
import * as React from "react";

interface PropsCollapseButton {
  collapsed: boolean;
  onChange(newValue: boolean): void;
}

export const CollapseButton: React.FC<PropsCollapseButton> = (props) => {
  const { collapsed, onChange } = props;
  return (
    <Button
      size="small"
      icon={collapsed ? <PlusOutlined /> : <MinusOutlined />}
      onClick={() => onChange(!collapsed)}
    />
  );
};
